const catalogueImages = [
  "/catalogue/01.jpg",
  "/catalogue/02.jpg",
  "/catalogue/03.jpg",
  "/catalogue/04.jpg",
  "/catalogue/05.jpg",
  "/catalogue/06.jpg",
  "/catalogue/07.jpg",
  "/catalogue/08.jpg",
  "/catalogue/09.jpg",
  "/catalogue/10.jpg",
];

function CataloguePage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, #f8fafc 0%, #f0fdf4 24%, #f8fafc 100%)",
        padding: "34px 26px 52px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <section style={{ display: "grid", gap: "22px", justifyItems: "center" }}>
          {catalogueImages.map((image, index) => (
            <article
              key={image}
              style={{
                background: "white",
                border: "1px solid #e2e8f0",
                boxShadow: "0 12px 28px rgba(15,23,42,0.07)",
                overflow: "hidden",
                borderRadius: "0",
                width: "100%",
                maxWidth: "1080px",
              }}
            >
              <img
                src={image}
                alt={`Manna catalogue slide ${index + 1}`}
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "85vh",
                  objectFit: "contain",
                  display: "block",
                  background: "#f8fafc",
                  borderRadius: "0",
                }}
              />
            </article>
          ))}
        </section>
      </div>
    </div>
  );
}

export default CataloguePage;
